import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';

import { makeStyles } from '@material-ui/core/styles';

import { showSuccessSnackbar } from 'modules/snackbar';
import {
  getCategoryList,
  getCampaignCategoryList,
  getOpenrtbCategoryList,
  addCategory,
  modifySeqCategory,
  deleteCategory,
  moveCategory,
  categoryMappingSave,
} from 'lib/api/category';
import { userTpCode } from 'lib/api/code';

import CurrentStatus from 'components/atoms/CurrentStatus';
import MbInput from 'components/atoms/MbInput';
import MbButton from 'components/atoms/MbButton';
import NewButton from 'components/molecules/NewButton';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import FunctionWrap from 'components/molecules/FunctionWrap';
import FilterCollection from 'components/organisms/FilterCollection';
import MbTabs from 'components/organisms/MbTabs';
import Modal from 'components/organisms/NewModal';

import AllButtonBox from './AllButtonBox';
import CategoryCheckBox from './CategoryCheckBox';
import ModalCategory from './ModalCategory';
import Mapping from './Mapping';

const useStyles = makeStyles((theme) => ({
  categoryWrap: { display: 'block' },
  categoryBox: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 10,
    padding: '20px 10px',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    '& > div:first-child': {
      paddingRight: 20,
      borderRight: '1px solid #ebebeb',
    },
  },
  oDepth: {
    minWidth: 140,
    marginRight: 10,
    '& > div': { marginBottom: 5 },
    '& > div:last-child': { marginBottom: 0 },
  },
  rightDepthBox: {
    '& > div:last-child': {
      marginBottom: '0',
    },
  },
  rtbRightBox: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > div': {
      width: 'auto',
      marginTop: 0,
      padding: 0,
      ' & > div': {
        borderRight: 0,
      },
    },
  },
  DepthItem: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: 10,
    // '& > div:last-child': { padding: '10px 20px' },
  },
  sDepth: {
    minWidth: 140,
    padding: 10,
    borderRight: '1px solid #ebebeb',
    marginRight: 30,
    '& > div': { marginBottom: 5 },
    '& > div:last-child': { marginBottom: 0 },
  },
  tDepth: {
    display: 'flex',
    flexWrap: 'wrap',
    '& > div': {
      marginRight: 10,
    },
  },
  tDepthItem: {
    margin: '5px 10px 5px 0;',
    minWidth: 100,
  },
  depthWrap: {
    '& > div > div': {
      '&:first-child': {
        marginTop: 10,
      },
      marginBottom: 10,
    },
  },
  tabSectionArea: {
    '& > div': {
      marginBottom: 10,
    },
  },
  button: {
    minWidth: 50,
    padding: 3,
  },
  modalInput: {
    width: 200,
    '& input': {
      width: '100%',
    },
  },
  funcBtn: {
    padding: 0,
  },
  btnColorEdit: {
    color: '#d90',
  },
  btnColorDelete: {
    color: '#e0a',
  },
  isRtbEditWrap: {
    '& > div': {
      display: 'block',
      '&:first-child': {
        marginBottom: 10,
      },
    },
  },
  titleWrap: {
    display: 'flex',
    alignItems: 'center',
    '& > div:first-child': {
      marginRight: 10,
    },
    '& > p': {
      marginTop: 0,
      marginBottom: 0,
    },
  },
}));

const List = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const dispatch = useDispatch();
  const { categoryType } = props;
  const typeIsRtb = categoryType === 'openrtb';

  const initParams = {
    userTpCode: typeIsRtb ? '' : '01',
    sort: '01',
  };
  const refuserTpCode = useRef(initParams);
  const [params, setParams] = useState(initParams);
  let initFilterList = {
    userTpCode: [],
    hirnkSeq: [],
    sHirnkSeq: {
      cnt: 0,
    },
    campaign: [{ CODE_ID: '01', CODE_DESC: t('모비온/쇼플 캠페인') }],
  };
  const refFilterList = useRef(initFilterList);
  const [filterList, setFilterList] = useState(initFilterList);

  const initInputError = {
    userTpCode: false,
    ctgrNm: false,
    sort: false,
  };
  const [inputError, setInputError] = useState(initInputError);
  const [tableData, setTableData] = useState(false);
  const [loading, setLoading] = useState({
    filter: true,
    table: true,
    func: true,
  });
  const initMappingData = {
    open: false,
    data: {
      sRow: {
        tRow: {},
      },
    },
  };
  const [mappingData, setMappingData] = useState(initMappingData);

  const initModal = {
    open: false,
    code: null,
    params: {
      userTpCode: '01',
      hirnkSeq: 'all',
      sHirnkSeq: 'all',
    },
    modalTitle: '',
    confirmBtnTitle: '',
    message: '',
  };
  const refModal = useRef(initModal);
  const [modal, setModal] = useState(initModal);

  let initSnackbar = {
    open: false,
    variant: 'success',
    message: '',
  };
  const [snackbar, setSnackbar] = useState(initSnackbar);
  const [selectedSeqs, setSelectedSeqs] = useState([]);

  useEffect(() => {
    if (categoryType === 'media') {
      userTpCode()
        .then((response) => {
          const { data } = response.data;
          refFilterList.current = {
            ...refFilterList.current,
            userTpCode: data,
          };
        })
        .catch((error) => {
          console.log('error');
          handleClickSnackbar({
            message: error,
            option: {
              type: 'error',
            },
          });
        });
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, [params]);

  useEffect(() => {
    if (JSON.stringify(refFilterList.current) !== JSON.stringify(filterList)) {
      setFilterList(refFilterList.current);
    }
    // eslint-disable-next-line
  }, [refFilterList.current]);

  useEffect(() => {
    if (refuserTpCode.current !== params) {
    }
    // eslint-disable-next-line
  }, [refuserTpCode.current]);

  /**
   * 페이지 리스트 데이터를 호출하는 함수
   */
  const getData = () => {
    if (categoryType === 'media') {
      getCategoryList(params)
        .then((response) => {
          const { data } = response.data;
          setTableData(data);
          refFilterList.current = {
            ...refFilterList.current,
            hirnkSeq: data.oDepth.data,
          };
        })
        .catch((error) => {
          handleClickSnackbar({
            message: error,
            option: {
              type: 'error',
            },
          });
        })
        .finally(() => {
          setLoading({
            ...loading,
            filter: false,
            table: false,
            func: false,
          });
        });
    } else if (typeIsRtb) {
      getOpenrtbCategoryList()
        .then((response) => {
          const { data } = response.data;
          setTableData(data);
          refFilterList.current = {
            ...refFilterList.current,
            hirnkSeq: data.oDepth.data,
          };
        })
        .catch((error) => {
          handleClickSnackbar({
            message: error,
            option: {
              type: 'error',
            },
          });
        })
        .finally(() => {
          setLoading({
            ...loading,
            filter: false,
            table: false,
            func: false,
          });
        });
    } else {
      getCampaignCategoryList()
        .then((response) => {
          const { data } = response.data;
          setTableData(data);
          refFilterList.current = {
            ...refFilterList.current,
            hirnkSeq: data.oDepth.data,
          };
        })
        .catch((error) => {
          handleClickSnackbar({
            message: error,
            option: {
              type: 'error',
            },
          });
        })
        .finally(() => {
          setLoading({
            ...loading,
            filter: false,
            table: false,
            func: false,
          });
        });
    }
  };

  /**
   * 카테고리 타입, 카테고리 키 변경 이벤트 함수
   * @param newParams
   */
  const handleFilter = (newParams) => {
    if (typeIsRtb && newParams.target.name === 'userTpCode') {
      const { name, value } = newParams.target;
      refuserTpCode.current = {
        ...refuserTpCode.current,
        [name]: value,
      };
    } else if (
      modal.code === 'edit' &&
      (newParams.target.name === 'ctgrNm' ||
        newParams.target.name === 'modifySeq')
    ) {
      if (modal.params[newParams.target.name] !== newParams.target.value) {
        setModal({
          ...modal,
          params: {
            ...modal.params,
            [newParams.target.name]: newParams.target.value,
          },
        });
      }
    } else {
      setParams({ ...newParams });
      setLoading({
        ...loading,
        table: true,
      });
    }
  };

  const setSelectedSeqsFunc = (seqs) => {
    setSelectedSeqs(seqs);
  };

  /**
   * modal 열어주는 함수
   */
  const handleModalOpen = (e) => {
    const { name } = e.currentTarget;
    let newModal = { ...modal };
    setFilterList({
      ...filterList,
      sHirnkSeq: {
        ...initFilterList.sHirnkSeq,
      },
    });
    newModal = {
      ...newModal,
      params: {
        ...initModal.params,
        userTpCode: params.userTpCode,
      },
    };
    if (name === 'add') {
      newModal = {
        ...newModal,
        modalTitle: '카테고리 등록',
        confirmBtnTitle: '등록',
      };
      setInputError(initInputError);
    } else if (name === 'edit') {
      newModal = {
        ...newModal,
        modalTitle: '카테고리 수정',
        confirmBtnTitle: '수정',
      };
    } else if (name === 'delete') {
      newModal = {
        ...newModal,
        modalTitle: '카테고리 삭제',
        confirmBtnTitle: '삭제',
      };
    } else if (name === 'move') {
      newModal = {
        ...newModal,
        modalTitle: '카테고리 이동',
        confirmBtnTitle: '이동',
      };
      setFilterList({
        ...filterList,
        sHirnkSeq: { cnt: 0 },
      });
    }
    newModal = {
      ...newModal,
      open: true,
      code: name,
    };
    if (name === 'add' || name === 'move') {
      setModal(newModal);
    } else {
      refModal.current = newModal;
    }
  };
  /**
   * 수정 버튼 클릭했을 때 실행되는 함수
   */
  const handleEdit = (e, row, depth) => {
    handleModalOpen(e);
    const { CTGR_SEQ, CTGR_NM } = row;
    let newModal = { ...refModal.current };
    newModal = {
      ...newModal,
      params: {
        seq: CTGR_SEQ,
        depth: depth,
        categoryType: categoryType,
        ctgrNm: CTGR_NM,
      },
    };
    setModal(newModal);
  };

  /**
   * 삭제 버튼 클릭했을 때 실행되는 함수
   */
  const handleDelete = (e, row, depth) => {
    handleModalOpen(e);
    const { CTGR_SEQ, CTGR_NM } = row;
    let newModal = { ...refModal.current };
    newModal = {
      ...newModal,
      params: {
        seqs: CTGR_SEQ,
        depth: depth,
        categoryType: categoryType,
        ctgrNm: CTGR_NM,
      },
    };
    setModal({ ...newModal });
  };

  /**
   * 선택 이동 버튼을 클릭했을 때 실행되는 함수
   * @param e
   */
  const handleMove = (e) => {
    if (selectedSeqs.length > 0) {
      handleModalOpen(e);
    } else {
      setSnackbar({
        ...snackbar,
        open: true,
        variant: 'error',
        message: '이동할 카테고리를 선택하세요.',
      });
    }
  };

  /**
   * 체크박스 삭제 버튼 클릭했을 때 실행되는 함수
   */
  const handleDeletes = (e) => {
    handleModalOpen(e);
    let newModal = { ...refModal.current };
    newModal = {
      ...newModal,
      params: {
        ctgrNm: '',
        seqs: selectedSeqs.join(', '),
        depth: 3,
        categoryType: categoryType,
      },
    };
    setModal({ ...newModal });
  };

  /**
   * 모달 닫아주는 함수
   */
  const handleModalClose = () => {
    let newModal;
    newModal = {
      ...modal,
      open: false,
    };
    setModal(newModal);
  };

  /**
   * 모달에 submit 버튼을 눌렀을 때 실행되는 함수
   */
  const handleSubmit = () => {
    let checkError = { ...inputError };
    if (
      modal.code !== 'move' &&
      modal.code !== 'delete' &&
      (typeof modal.params.ctgrNm === 'undefined' || modal.params.ctgrNm === '')
    ) {
      checkError = {
        ...checkError,
        ctgrNm: true,
      };
    } else {
      checkError = {
        ...checkError,
        ctgrNm: false,
      };
    }
    if (modal.code === 'add' && refuserTpCode.current.userTpCode === '') {
      checkError = {
        ...checkError,
        userTpCode: true,
      };
    } else {
      checkError = {
        ...checkError,
        userTpCode: false,
      };
    }
    if (modal.code === 'add' && modal.params.sort === '') {
      checkError = {
        ...checkError,
        sort: true,
      };
    } else {
      checkError = {
        ...checkError,
        sort: false,
      };
    }

    if (JSON.stringify(inputError) !== JSON.stringify(checkError)) {
      setInputError(checkError);
    }
    for (let key in checkError) {
      if (checkError[key]) {
        return;
      }
    }

    let depth =
      modal.tabState === 'sDepth'
        ? 1
        : modal.tabState === 'tDepth'
        ? 2
        : modal.tabState === 'oDepth' && 3;
    let newSnackbar = { ...snackbar };

    if (modal.params.sHirnkSeq === 'all') {
      if (depth === 3 || modal.code === 'move') {
        newSnackbar = {
          ...newSnackbar,
          open: true,
          variant: 'error',
          message: t('2차분류를 선택하세요.'),
        };
      }
    }
    if (modal.params.hirnkSeq === 'all') {
      if (depth === 2 || depth === 3 || modal.code === 'move') {
        newSnackbar = {
          ...newSnackbar,
          open: true,
          variant: 'error',
          message: t('1차분류를 선택하세요.'),
        };
      }
    }
    if (JSON.stringify(snackbar) !== JSON.stringify(newSnackbar)) {
      setSnackbar(newSnackbar);
      return;
    }
    if (modal.code === 'add') {
      let resultParams = {
        userTpCode: typeIsRtb
          ? refuserTpCode.current.userTpCode
          : params.userTpCode,
        depth: depth,
        categoryType: categoryType,
        hirnkSeq:
          modal.params.sHirnkSeq !== 'all'
            ? modal.params.sHirnkSeq
            : modal.params.hirnkSeq,
        ctgrNm: modal.params.ctgrNm,
      };
      if (categoryType === 'campaign' && depth === 3) {
        resultParams = {
          ...resultParams,
          sort: modal.params.sort,
        };
      }
      addCategory(resultParams)
        .then((response) => {
          const { message } = response.data;
          setSnackbar({
            ...snackbar,
            open: true,
            variant: 'success',
            message: message,
          });
        })
        .catch((error) => {
          setSnackbar({
            ...snackbar,
            open: true,
            variant: 'error',
            message: error,
          });
        })
        .finally(() => {
          getData();
        });
    } else if (modal.code === 'edit') {
      modifySeqCategory(modal.params)
        .then((response) => {
          const { message } = response.data;
          setSnackbar({
            ...snackbar,
            open: true,
            variant: 'success',
            message: message,
          });
        })
        .catch((error) => {
          setSnackbar({
            ...snackbar,
            open: true,
            variant: 'error',
            message: error,
          });
        })
        .finally(() => {
          getData();
        });
    } else if (modal.code === 'delete') {
      deleteCategory(modal.params)
        .then((response) => {
          const { message } = response.data;
          setSnackbar({
            ...snackbar,
            open: true,
            variant: 'success',
            message: message,
          });
        })
        .catch((error) => {
          setSnackbar({
            ...snackbar,
            open: true,
            variant: 'error',
            message: error,
          });
        })
        .finally(() => {
          getData();
          setSelectedSeqs([]);
        });
    } else if (modal.code === 'move') {
      let newParams = {
        seqs: selectedSeqs.join(', '),
        categoryType: categoryType,
        hirnkSeq: modal.params.sHirnkSeq,
      };
      moveCategory(newParams)
        .then((response) => {
          const { message } = response.data;
          setSnackbar({
            ...snackbar,
            open: true,
            variant: 'success',
            message: message,
          });
        })
        .catch((error) => {
          setSnackbar({
            ...snackbar,
            open: true,
            variant: 'error',
            message: error,
          });
        })
        .finally(() => {
          getData();
          setSelectedSeqs([]);
        });
    }

    setModal({
      ...modal,
      open: false,
    });
    setLoading({
      ...loading,
      table: true,
    });
  };

  /**
   * 모달 카테고리 이름 변경하는 함수
   * @param e
   */
  const handleModalChange = (e) => {
    const { name, value } = e.target;

    let tempModal = { ...modal };
    tempModal = {
      ...tempModal,
      params: {
        ...modal.params,
        [name]: value,
      },
    };
    setModal({ ...tempModal });
    if (value !== '') {
      setInputError({
        ...inputError,
        [name]: false,
      });
    } else {
      setInputError({
        ...inputError,
        [name]: true,
      });
    }
  };

  /**
   * 모달에 있는 값을 변경할 때 사용하는 함수
   * @param newParams
   */
  const handleModalParams = (newParams) => {
    let tempParams;
    if (JSON.stringify(modal.params) !== JSON.stringify(newParams)) {
      tempParams = newParams;
      for (let key in newParams) {
        if (modal.params[key] !== newParams[key]) {
          tempParams = {
            ...tempParams,
            [key]: tempParams[key],
          };
          if (key === 'hirnkSeq') {
            if (typeof tableData.sDepth[newParams.hirnkSeq] !== 'undefined') {
              refFilterList.current = {
                ...refFilterList.current,
                sHirnkSeq: tableData.sDepth[newParams.hirnkSeq].data,
              };
            } else {
              setFilterList({
                ...filterList,
                sHirnkSeq: {
                  cnt: 0,
                },
              });
            }

            tempParams = {
              ...tempParams,
              sHirnkSeq: 'all',
            };
          }
        }
      }
      setModal({
        ...modal,
        params: {
          ...tempParams,
        },
      });
    }
  };

  // /**
  //  * 스낵바 닫는 함수
  //  * 연속 클릭이 들어왔을 때는 기존 스낵바를 유지
  //  * @param event
  //  * @param reason
  //  */
  // const handleSnackBarClose = (event, reason) => {
  //   if (reason === 'clickaway') {
  //     return;
  //   }
  //   setSnackbar({
  //     ...snackbar,
  //     open: false,
  //     message: '',
  //   });
  // };

  /**
   * 스낵바 리덕스 값을 변경해주는 함수
   * @type {(...args: any[]) => any}
   */
  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  const handleCloseMapping = () => {
    setMappingData({
      ...mappingData,
      open: false,
    });
  };

  const handleConfirmMapping = (params) => {
    setMappingData({
      ...mappingData,
      open: false,
      loading: true,
    });
    categoryMappingSave(params)
      .then((response) => {
        const { message } = response.data;
        handleClickSnackbar({
          message: message,
          option: {
            type: 'success',
          },
        });
      })
      .catch((error) => {
        handleClickSnackbar({
          message: error,
          option: {
            type: 'error',
          },
        });
      })
      .finally(() => {
        setMappingData({
          ...initMappingData,
          loading: false,
        });
      });
  };

  return (
    <>
      <FunctionWrap loading={loading.func}>
        <NewButton
          type="modalBtn"
          name="add"
          onClick={handleModalOpen}
          disableRipple
          className={classes.funcBtn}
        >
          {t('등록')}
        </NewButton>
        {!typeIsRtb && (
          <>
            <NewButton
              type="modalBtn"
              name="move"
              onClick={handleMove}
              className={clsx(classes.funcBtn)}
            >
              {t('선택 이동')}
            </NewButton>
            <NewButton
              type="modalBtn"
              name="delete"
              onClick={handleDeletes}
              className={classes.funcBtn}
            >
              {t('선택 삭제')}
            </NewButton>
          </>
        )}
      </FunctionWrap>
      {!typeIsRtb && (
        <NewFilterWrap loading={loading.filter}>
          <FilterCollection
            label={t('카테고리 타입')}
            value={params.userTpCode}
            name="userTpCode"
            type="radio"
            labelKey="CODE_DESC"
            valueKey="CODE_ID"
            list={
              categoryType === 'media'
                ? filterList.userTpCode
                : categoryType === 'campaign' && filterList.campaign
            }
            params={params}
            callBack={handleFilter}
          />
        </NewFilterWrap>
      )}

      {mappingData.loading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            zIndex: 9999,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgb(255 255 255 / 29%)',
          }}
        >
          <CurrentStatus type="loading" />
        </div>
      )}
      {loading.table ? (
        <CurrentStatus type="loading" option="useMinHeight" />
      ) : (
        <>
          {tableData !== false && typeof tableData.oDepth.data !== 'undefined' && (
            <div className={classes.categoryWrap}>
              {tableData.oDepth.data.map((oRow, oRowIndex) => (
                <div className={classes.categoryBox} key={oRowIndex.toString()}>
                  <div className={classes.oDepth}>
                    <div className={classes.titleWrap}>
                      {categoryType !== 'campaign' && (
                        <NewButton
                          title={t('카테고리 맵핑')}
                          icon="faEdit"
                          iconBtn
                          onClick={(e) => {
                            setMappingData({
                              ...initMappingData,
                              open: true,
                              type: 'oRow',
                              data: oRow,
                            });
                          }}
                          disableRipple
                        />
                      )}
                      <p>
                        {oRow.CTGR_NM} ({oRow.CTGR_CNT})
                      </p>
                    </div>
                    <div>
                      [{t('코드')} : {oRow.CTGR_SEQ}]
                    </div>
                    <div>
                      <MbButton
                        filterButton
                        name="edit"
                        className={clsx(classes.button, classes.btnColorEdit)}
                        style={{ marginRight: 5 }}
                        onClick={(e) => handleEdit(e, oRow, 1)}
                      >
                        {t('수정')}
                      </MbButton>
                      <MbButton
                        filterButton
                        name="delete"
                        className={clsx(classes.button, classes.btnColorDelete)}
                        onClick={(e) => handleDelete(e, oRow, 1)}
                      >
                        {t('삭제')}
                      </MbButton>
                    </div>
                  </div>
                  {typeof tableData.sDepth[oRow.CTGR_SEQ] !== 'undefined' && (
                    <div
                      className={clsx(
                        classes.rightDepthBox,
                        typeIsRtb && classes.rtbRightBox
                      )}
                    >
                      {tableData.sDepth[oRow.CTGR_SEQ].data.map(
                        (sRow, sRowIndex) => {
                          return (
                            <div
                              className={classes.DepthItem}
                              key={sRowIndex.toString()}
                            >
                              <div
                                className={classes.sDepth}
                                key={`${sRow.CTGR_SEQ}tableCell`}
                              >
                                <div className={classes.titleWrap}>
                                  {categoryType !== 'campaign' && (
                                    <NewButton
                                      title={t('카테고리 맵핑')}
                                      icon="faEdit"
                                      iconBtn
                                      onClick={(e) => {
                                        setMappingData({
                                          ...initMappingData,
                                          open: true,
                                          type: 'sRow',
                                          data: { ...oRow, sRow: sRow },
                                        });
                                      }}
                                      disableRipple
                                    />
                                  )}
                                  <p>{sRow.CTGR_NM} </p>
                                  {!typeIsRtb && <>({sRow.CTGR_CNT})</>}
                                </div>
                                <div>
                                  [{t('코드')} : {sRow.CTGR_SEQ}]
                                </div>
                                <div>
                                  <MbButton
                                    filterButton
                                    name="edit"
                                    className={clsx(
                                      classes.button,
                                      classes.btnColorEdit
                                    )}
                                    style={{ marginRight: 5 }}
                                    onClick={(e) => handleEdit(e, sRow, 2)}
                                  >
                                    {t('수정')}
                                  </MbButton>
                                  <MbButton
                                    filterButton
                                    name="delete"
                                    className={clsx(
                                      classes.button,
                                      classes.btnColorDelete
                                    )}
                                    onClick={(e) => handleDelete(e, sRow, 2)}
                                  >
                                    {t('삭제')}
                                  </MbButton>
                                </div>
                              </div>

                              {typeof tableData.tDepth[sRow.CTGR_SEQ] !==
                                'undefined' && (
                                <div key={`${sRow.CTGR_SEQ}tableCell2`}>
                                  <div>
                                    <AllButtonBox
                                      key={`${sRow.CTGR_SEQ}allBtnBox`}
                                      tDepth={
                                        tableData.tDepth[sRow.CTGR_SEQ].data
                                      }
                                      setSelectedSeqs={setSelectedSeqsFunc}
                                      selectedSeqs={selectedSeqs}
                                    />
                                  </div>
                                  <div className={classes.tDepth}>
                                    {tableData.tDepth[sRow.CTGR_SEQ].data.map(
                                      (tRow, tRowIndex) => {
                                        return (
                                          <div key={tRowIndex.toString()}>
                                            <div
                                              className={clsx(
                                                classes.tDepthItem,
                                                classes.titleWrap
                                              )}
                                            >
                                              {categoryType !== 'campaign' && (
                                                <NewButton
                                                  title={t('카테고리 맵핑')}
                                                  icon="faEdit"
                                                  iconBtn
                                                  onClick={(e) => {
                                                    setMappingData({
                                                      ...initMappingData,
                                                      open: true,
                                                      type: 'tRow',
                                                      data: {
                                                        ...oRow,
                                                        sRow: {
                                                          ...sRow,
                                                          tRow: tRow,
                                                        },
                                                      },
                                                    });
                                                  }}
                                                  disableRipple
                                                />
                                              )}
                                              <CategoryCheckBox
                                                key={`${tRow.CTGR_SEQ}checkBox`}
                                                selectedSeq={tRow.CTGR_SEQ}
                                                selectedSeqs={selectedSeqs}
                                              />
                                              <span>{tRow.CTGR_NM}</span>
                                            </div>
                                            <div>
                                              <MbButton
                                                filterButton
                                                name="edit"
                                                className={clsx(
                                                  classes.button,
                                                  classes.btnColorEdit
                                                )}
                                                style={{ marginRight: 5 }}
                                                onClick={(e) =>
                                                  handleEdit(e, tRow, 3)
                                                }
                                              >
                                                {t('수정')}
                                              </MbButton>
                                              <MbButton
                                                filterButton
                                                name="delete"
                                                className={clsx(
                                                  classes.button,
                                                  classes.btnColorDelete
                                                )}
                                                onClick={(e) =>
                                                  handleDelete(e, tRow, 3)
                                                }
                                              >
                                                {t('삭제')}
                                              </MbButton>
                                            </div>
                                          </div>
                                        );
                                      }
                                    )}
                                  </div>
                                </div>
                              )}
                            </div>
                          );
                        }
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </>
      )}
      <Modal
        open={modal.open}
        headerOpen={modal.headerOpen}
        headerTitle={modal.modalTitle}
        handleClose={handleModalClose}
        confirmBtnTitle={modal.confirmBtnTitle}
        cancelBtnOpen={modal.cancelBtnOpen}
        cancelBtnTitle={modal.cancelBtnTitle}
        confirmOnClick={handleSubmit}
        width={
          modal.code === 'add' || modal.code === 'move' ? '600px' : undefined
        }
      >
        {modal.code === 'add' && (
          <div className={classes.tabSectionArea}>
            <MbTabs
              isMenuTab={false}
              params={modal.params}
              name="UsersModal"
              initValue="sDepth"
              getCurTab={(cur) => {
                setModal({
                  ...modal,
                  params: {
                    ...initModal.params,
                    userTpCode: modal.params.userTpCode,
                  },
                  tabState: cur,
                });
                setInputError(initInputError);
                setFilterList({
                  ...filterList,
                  sHirnkSeq: [],
                });
              }}
              tabMenuList={(() => {
                const result = new Map();
                result.set('sDepth', {
                  menuUrl: 'sDepth',
                  menuSeq: 'sDepth',
                  menuNm: t('1차 카테고리'),
                });
                result.set('tDepth', {
                  menuUrl: 'tDepth',
                  menuSeq: 'tDepth',
                  menuNm: t('2차 카테고리'),
                });
                if (!typeIsRtb) {
                  result.set('oDepth', {
                    menuUrl: 'oDepth',
                    menuSeq: 'oDepth',
                    menuNm: t('3차 카테고리'),
                  });
                }

                return result;
              })()}
              tabs={{
                sDepth: {
                  tabComponent: (
                    <ModalCategory
                      tabState={modal.tabState}
                      modal={modal}
                      filterList={filterList}
                      categoryType={categoryType}
                      inputError={inputError}
                      refuserTpCode={refuserTpCode.current}
                      handleModalParams={handleModalParams}
                      handleModalChange={handleModalChange}
                      handleFilter={handleFilter}
                      params={params}
                    />
                  ),
                },
                tDepth: {
                  tabComponent: (
                    <ModalCategory
                      tabState={modal.tabState}
                      modal={modal}
                      filterList={filterList}
                      categoryType={categoryType}
                      inputError={inputError}
                      refuserTpCode={refuserTpCode.current}
                      handleModalParams={handleModalParams}
                      handleModalChange={handleModalChange}
                      handleFilter={handleFilter}
                      params={params}
                    />
                  ),
                },
                oDepth: {
                  tabComponent: (
                    <ModalCategory
                      tabState={modal.tabState}
                      modal={modal}
                      filterList={filterList}
                      categoryType={categoryType}
                      inputError={inputError}
                      refuserTpCode={refuserTpCode.current}
                      handleModalParams={handleModalParams}
                      handleModalChange={handleModalChange}
                      handleFilter={handleFilter}
                      params={params}
                    />
                  ),
                },
              }}
              isModal={true}
            />
          </div>
        )}
        {modal.code === 'edit' && (
          <div className={classes.isRtbEditWrap}>
            {typeIsRtb && (
              <MbInput
                useFilter
                name="modifySeq"
                defaultValue={modal.params.seq}
                error={inputError.modifySeq}
                inputLabel={t('카테고리 키')}
                onBlur={handleFilter}
                className={classes.modalInput}
              />
            )}
            <MbInput
              useFilter
              name="ctgrNm"
              defaultValue={modal.params.ctgrNm}
              error={inputError.ctgrNm}
              inputLabel={t('카테고리명')}
              onBlur={handleFilter}
              className={classes.modalInput}
            />
          </div>
        )}
        {modal.code === 'delete' && <p>{t('삭제하시겠습니까?')}</p>}
        {modal.code === 'move' && (
          <ModalCategory
            tabState={modal.tabState}
            modal={modal}
            filterList={filterList}
            categoryType={categoryType}
            inputError={inputError}
            refuserTpCode={refuserTpCode.current}
            handleModalParams={handleModalParams}
            handleModalChange={handleModalChange}
            handleFilter={handleFilter}
            params={params}
          />
        )}
      </Modal>
      <Mapping
        open={mappingData.open}
        data={mappingData.data}
        type={mappingData.type}
        categoryType={categoryType === 'media' ? '01' : typeIsRtb && '03'}
        handleClose={handleCloseMapping}
        confirmOnClick={handleConfirmMapping}
      />
    </>
  );
};

export default List;
